export default __webpack_public_path__ + "static/media/grid_img.33d58aa9.png";